import CategoryFA from './fa/fa.json'

const CategoryMessages = {
  fa: { ...CategoryFA },
}

export default CategoryMessages
